import { render, staticRenderFns } from "./BasicProfileDetail.vue?vue&type=template&id=9b36d718&"
import script from "./BasicProfileDetail.vue?vue&type=script&lang=js&"
export * from "./BasicProfileDetail.vue?vue&type=script&lang=js&"
import style0 from "./BasicProfileDetail.vue?vue&type=style&index=0&id=9b36d718&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports